import { CRUDEntity } from "../../abstracts/CRUDEntity";

export class WebsiteBuilder extends CRUDEntity{
    constructor(){
        super();
        this.entityClass = 'business-page';
        this.urlRoot = '/settings/website-builder';
        this.sectionRootUrl = '/settings';

    }
}
